import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'mmg-maximizable-form',
  templateUrl: './maximizable-form.component.html',
  styleUrls: ['./maximizable-form.component.scss']
})
export class MaximizableFormComponent<T> {
  @Input() formTitle: string = '';
  @Input() showCloseButton: boolean = true;
  @Input() showSaveButton: boolean = true;
  @Input() disableSaveButton: boolean = false;

  @Output() readonly onClose = new EventEmitter<void>();
  @Output() readonly onSave = new EventEmitter<void>();

  isMaximized = false;

  constructor(private readonly dialogRef: MatDialogRef<T>)
  { }

  close(): void {
    this.onClose.emit();
  }

  save(): void {
    this.onSave.emit();
  }

  maximize(): void {
    this.isMaximized = !this.isMaximized;
    const perc = this.isMaximized ? '100%' : '80%';
    this.dialogRef.updateSize(perc, perc);
  }
}